import classnames from 'classnames'
import { Text, Button } from '@krea/common/shared-components'
import styles from './NavigateAction.module.scss'

const NavigateAction = ({ button: { text, onClick }, title, className }) => {
	return (
		<div className={classnames(styles.mainDiv, className)}>
			<Text className={styles.title}>{title}</Text>

			{text && onClick && (
				<Button variant="text" onClick={onClick}>
					{text}
				</Button>
			)}
		</div>
	)
}

export default NavigateAction
